var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-bottom":"16px"}},[(!_vm.$tools.isEmpty(_vm.name))?_c('div',{staticClass:"caption mb-1"},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_c('div',{staticClass:"position-relative body-2"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }